import { useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui";
import { Route } from "@/routes/_authed-tw/admin/contratos-anualizados/$id";
import { useContratoAdmin } from "../hooks/use-contratos";
import { ContratoForm } from "./ContratoForm";

/**
 * Ruta dedicada de edición de un contrato anualizado
 * (`/admin/contratos-anualizados/$id`, por el id de la versión · la clave puede
 * repetirse entre años fiscales). Carga esa versión y renderiza el form · al
 * guardar o cancelar regresa al listado.
 */
export function AdminEditarContratoPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: ca } = useContratoAdmin(id);

  const volver = () => void navigate({ to: "/admin/contratos-anualizados" });
  const etiqueta = ca.fecha ? `${ca.clave} · ${new Date(ca.fecha).getFullYear()}` : ca.clave;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <PageHeader
        title={`Editar contrato anualizado ${etiqueta}`}
        description="Editar el contrato crea una versión nueva · los conceptos provienen del XML."
        breadcrumbs={[
          { label: "Inicio", href: "/dashboard" },
          { label: "Admin", href: "/admin" },
          { label: "Contratos anualizados", href: "/admin/contratos-anualizados" },
          { label: etiqueta },
        ]}
      />
      <ContratoForm inicial={ca} onDone={volver} />
    </div>
  );
}
